import React, { useEffect, useState } from "react";
import { platformApi } from "../../../../api";
import { Table, Spin, message } from "antd";
import moment from "moment";
import OrderManagementForm from "./OrderManagementForm";

const OrderManagementTable = ({ pagination, modifyAccess, deleteAccess, data, setData, setCount, searchString, page, limit }) => {
  const [loading, setLoading] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [editable, setEditable] = useState(false);

  useEffect(() => {
    getData();
  }, [page, limit, searchString]);


  const getData = async () => {
    setLoading(true);
    try {
      console.log("here 2");
      
      const response = await platformApi.post(
        `/api/customerSpareOrderRouter/spare-orders`, {page, size: limit, searchString}
      );
      if (response.data.code === 200) {
        setData(response.data.data?.sparePartOrders || []);
        setCount(response.data.data?.count);
      } else {
        message.error("Unable to fetch order management data");
      }
    } catch (error) {
      console.error("Error getting order management table:", error);
      message.error("Failed to fetch order management data");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Order Date",
      dataIndex: "orderDate",
      key: "date",
      render: (record) => (
        <span>{record && moment(record).format("DD-MM-YYYY")}</span>
      ),
    },
    {
        title: "Order No",
        key: "orderNumber",
        render: (record) =>
          record?.customerSpareOrder
            ? (record?.customerSpareOrder?.orderType === "JOBCARD" || record?.customerSpareOrder?.orderType === "JOB_CARD")
              ? record?.customerSpareOrder?.jobCard?.jobNo
              : record?.customerSpareOrder?.orderNumber
            : record?.saleSpareInvoice
            ? record?.saleSpareInvoice?.invoiceNumber
            : "-",      
    },
    {
      title: "Ordered Part",
      dataIndex: "orderedPartNo",
      key: "partNo",
      render: (record) => (
        <span>{record && `${record.partNumber} - ${record.partName}`}</span>
      ),
    },
    {
      title: "Order Type",
      dataIndex: "customerSpareOrder",
      key: "orderType",
      render: (text) => text?.orderType?.replace(/_/g, " "),
    },
    {
      title: "Customer",
      dataIndex: "customerSpareOrder",
      key: "customerName",
      render: (_, record) => {
        const customerName =
          record?.customerSpareOrder?.partyName?.name ||
          record?.saleSpareInvoice?.partyName?.name ||
          "-";
        return <span>{customerName}</span>;
      },
    },    
    {
      title: "Quantity",
      dataIndex: "orderedQuantity",
      key: "quantity",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <span
          style={{
            color:
              text === "PENDING"
                ? "#ff4d4f"
                : text === "ORDERED"
                ? "#ad6800"
                : text === "PARTIALLY_RECEIVED"
                ? "#ff7a45"
                : text === "RECEIVED"
                ? "#237804"
                : "#000000",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: <span>Actions</span>,
      key: "actions",
      render: (data) => (
        <div>
          {modifyAccess ? (
            <span
              onClick={(event) => {
                event.stopPropagation();
                setSelectedData(data);
                setEditable(true);
                setModalOpen(true);
              }}
              className="linkylink"
            >
              {data.status == "RECEIVED" ? "View" : "Modify"}
            </span>
          ) : (
            <span></span>
          )}
        </div>
      ),
    },
  ];

  return (
    <div>
      <Spin spinning={loading}>
        <Table
          rowKey={(record) => record.id}
          pagination={pagination}
          columns={columns}
          style={{ cursor: "pointer" }}
          dataSource={data}
          onRow={(record) => ({
            onClick: () => {
              setSelectedData(record);
              setEditable(false);
              setModalOpen(true);
            },
          })}
        />
      </Spin>

      {modalOpen && (
        <OrderManagementForm
          selectedData={selectedData}
          open={modalOpen}
          close={() => {
            setModalOpen(false);
            getData();
          }}
          refreshData={getData}
          editable={editable}
        />
      )}
    </div>
  );
};

export default OrderManagementTable;
